import { render, staticRenderFns } from "./PedidoDetalhado.vue?vue&type=template&id=177fcb6e&"
import script from "./PedidoDetalhado.vue?vue&type=script&lang=js&"
export * from "./PedidoDetalhado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports